import { MediaDto, mediaFromDto } from "@domain/media/dtos";
import { Identity, UserKyc } from "./userKyc";
import { IdentityDraft, UserKycDraft } from "./userKycDraft";

export interface IdentityToDto extends Omit<IdentityDraft, "idPassportAsset"> {
	idPassportAssetId: string;
}
export interface IdentityFromDto extends Omit<IdentityDraft, "idPassportAsset"> {
	idPassportAsset?: MediaDto;
}
export interface UserKycDto extends Omit<UserKycDraft, "identity"> {
	identity: IdentityToDto;
}
export interface UserKycFromDto extends Omit<UserKyc, "identity"> {
	identity?: IdentityFromDto;
}

export const userKycToDto = (draft: UserKycDraft): UserKycDto => {
	return {
		...draft,
		identity: identityToDto(draft.identity),
	};
};
export const userKycFromDto = (dto: UserKycFromDto): UserKyc => {
	const { identity } = dto;
	return {
		...dto,
		identity: identity ? identityFromDto(identity) : { typePassport: "ID", idPassportId: "" },
	};
};

function identityToDto(draft: IdentityDraft): IdentityToDto {
	return {
		...draft,
		idPassportAssetId: draft.idPassportAsset?.id ?? "",
	};
}
function identityFromDto(dto: IdentityFromDto): Identity {
	return {
		...dto,
		idPassportAsset: dto.idPassportAsset && mediaFromDto(dto.idPassportAsset),
		typePassport: dto.typePassport ?? "ID",
		idPassportId: dto.idPassportId ?? "",
	};
}
